// Models
import { CampaignDesignation, DesignationsPageResponse } from 'models/Designation'

// Redux services
import { fetchDesignation, getCampaignDesignations } from 'redux/services/designation'

// Local
import { RootState, TypedDispatch } from 'redux/store'
import { FinalizeOrderArgs } from '../types'

/**
 * Updates the transaction with designation information.
 * @param cid - Campaign ID
 * @param transaction - Transaction details
 */
const getDesignationId = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
  args: FinalizeOrderArgs,
): Promise<number | undefined> => {
  /*
   * CL-49337: Since designations can be set in url by orgs
   * we need to check if the stored designation is valid for the campaign before using it
   * If it's not valid, we'll fall back to the default designation for the campaign
   */
  const storedDesignationId = store.order.designation.value.designationId

  if (storedDesignationId) {
    try {
      const isStoredDesignationValid = await dispatch(
        fetchDesignation.initiate({
          designationId: storedDesignationId,
        }),
      ).unwrap()

      if (isStoredDesignationValid && isStoredDesignationValid.id === storedDesignationId) {
        return storedDesignationId
      }
    } catch (error) {
      console.error(
        `Error fetching designation ${storedDesignationId} for campaign ${args.campaign.campaign_id}:`,
        error,
      )
    }
  }

  // Fetch the default designation for the campaign
  const designations: DesignationsPageResponse<CampaignDesignation> = await dispatch(
    getCampaignDesignations.initiate({
      campaignId: String(args.campaign.campaign_id),
      params: { filter: { is_default: true, is_active: true } },
    }),
  ).unwrap()

  if (designations.total > 0) {
    return designations.data[0].id
  }

  // Should always have a default designation, but just in case
  return undefined
}

export default getDesignationId
